var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[_c('v-main',[(_vm.loaded)?_c('webplayer-layout',{attrs:{"data-cy":"web-player"}}):_c('v-progress-circular')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }